export const validateLeadForm = (formData, trans) => {
  const errors = {};
  let formIsValid = true;
  if (!formData.firstName) {
    errors.firstName =
      trans("Common.firstName") + " " + trans("Common.isRequired");
    formIsValid = false;
  }

  // Validate email
  if (!formData.email || !/\S+@\S+\.\S+/.test(formData.email)) {
    errors.email = trans("Common.validEmail");
    formIsValid = false;
  }

  return { isValid: formIsValid, errors };
};
